import React from "react";

import { Autocomplete, Checkbox, Chip, TextField } from "@mui/material";
import { Close, ExpandMore } from "@mui/icons-material";

import { dropDownSearchChipSX, dropDownSearchSX } from "./index.styles";
import { DropDownList } from "utils/types";

interface DropDownListTypeSearchType {
  isError?: boolean;
  label?: string;
  placeholder?: string;
  value: DropDownList | DropDownList[] | [];
  helperText?: string;
  options: DropDownList[];
  disableOptionsList?: DropDownList[];
  disabled?: boolean;
  isMultiSelect?: boolean;
  name?: string;
  handleChange?: (
    event: React.ChangeEvent<{}>,
    value: any,
    name: string
  ) => void;
  handleInputChange?: (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => void;
  popupIcon?: React.ReactNode;
  loading?: boolean;
  chipSX?: object;
  sx?: object;
}

const SearchableDropDown = ({
  isError,
  label,
  placeholder,
  value,
  helperText,
  options,
  disableOptionsList,
  handleChange,
  handleInputChange,
  disabled,
  isMultiSelect,
  popupIcon,
  loading,
  chipSX,
  sx,
}: DropDownListTypeSearchType) => {
  const renderTags = (tagValue: any, getTagProps: any) =>
    tagValue.map((option: DropDownList, index: number) => (
      <Chip
        variant="outlined"
        label={option.label}
        {...getTagProps({ index })}
        sx={{ ...dropDownSearchChipSX, ...chipSX }}
        deleteIcon={<Close />}
      />
    ));

  return (
    <Autocomplete
      disabled={disabled}
      multiple={isMultiSelect}
      id="dropdown-search"
      value={value}
      options={options}
      getOptionDisabled={(option) =>
        disableOptionsList?.some(
          (selectedOption) =>
            JSON.stringify(selectedOption) === JSON.stringify(option)
        ) || false
      }
      isOptionEqualToValue={(option, value) => {
        return option.label === value.label && option.value === value.value;
      }}
      getOptionLabel={(option) => (option.label ? option.label : "")}
      disableCloseOnSelect={isMultiSelect ? true : false}
      onChange={handleChange}
      popupIcon={popupIcon ? popupIcon : <ExpandMore />}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          error={isError}
          variant="outlined"
          label={label}
          onChange={handleInputChange}
          placeholder={placeholder}
          helperText={isError && helperText}
        />
      )}
      renderTags={isMultiSelect ? renderTags : undefined}
      sx={{ ...dropDownSearchSX, ...sx }}
      renderOption={(props, option, { selected }) => (
        <li {...props} key={option.value}>
          {isMultiSelect && (
            <Checkbox sx={{ p: "0 9px 0 0" }} checked={selected} />
          )}

          {option.label}
        </li>
      )}
    />
  );
};

export default React.memo(SearchableDropDown);
